import Image from 'next/image';
import React from 'react';

const UsaSessionsInfo = () => {
    return (
        <>
            <div className="md:col-span-6 lg:col-span-6">
                <div className="flex lg:flex-nowrap	md:flex-wrap items-center sessions-border-b mb-30">
                    <div className="mr-5">
                        <Image
                            alt="sessions in USA"
                            src="/img/icons/ic-vector.svg"
                            height="190"
                            width="167"
                            loading="eager"
                            data-aos="fade-left"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                        />
                    </div>
                    <div>
                        <h2 className="text-blue">Elevate Your Business with In-Person Strategy Sessions in the USA!</h2>
                    </div>
                </div>
                <div>
                    <div className="flex items-center mb-30">
                        <div className="mr-5">
                            <Image alt="rating star" src="/img/icons/ic-tailored.svg" height="50" width="50" loading="eager" />
                        </div>
                        <div>
                            <p className="text-textcolor mb-0 fw-500">
                                Tailored solutions for your business challenges, crafted just for you.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center mb-30">
                        <div className="mr-5">
                            <Image alt="rating star" src="/img/icons/ic-otimize.svg" height="50" width="50" loading="eager" />
                        </div>
                        <div>
                            <p className="text-textcolor mb-0 fw-500">
                                Optimize operations with cutting-edge software and mobile app strategies.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center mb-30">
                        <div className="mr-5">
                            <Image alt="rating star" src="/img/icons/ic-learn.svg" height="50" width="50" loading="eager" />
                        </div>
                        <div>
                            <p className="text-textcolor mb-0 fw-500">
                                Learn from success stories across industries and unlock new possibilities.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center mb-30">
                        <div className="mr-5">
                            <Image alt="rating star" src="/img/icons/ic-experience.svg" height="50" width="50" loading="eager" />
                        </div>
                        <div>
                            <p className="text-textcolor mb-0 fw-500">
                                Experience live demos and explore future-ready collaboration opportunities.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center mb-30">
                        <div className="mr-5">
                            <Image alt="rating star" src="/img/icons/ic-drive.svg" height="50" width="50" loading="eager" />
                        </div>
                        <div>
                            <p className="text-textcolor mb-0 fw-500">
                                Drive growth and innovation with a strategic partnership that lasts.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UsaSessionsInfo;
